export const languageMap = {
  en: 'en-US',
  ru: 'ru-RU',
} as { [key: string]: string }
